// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__Otphm","hand":"Home_hand__10TLc","wave":"Home_wave__tr7z1"};